import { render } from "./B2bPageBorradores.vue?vue&type=template&id=883ef066&scoped=true&lang=pug"
import script from "./B2bPageBorradores.vue?vue&type=script&lang=js"
export * from "./B2bPageBorradores.vue?vue&type=script&lang=js"

import "./B2bPageBorradores.vue?vue&type=style&index=0&id=883ef066&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883ef066"]])

export default __exports__